export default "__VITE_ASSET__NrjvhGkc__"